import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import {
  FaFileAlt, FaSyncAlt, FaUsers, FaCalendarTimes,
  FaLeaf, FaIndustry, FaUserTie, FaClipboardList
} from 'react-icons/fa';
import API_BASE_URL from '../../../config/api';

const Home = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE_URL}/dashboard/stats`)
      .then(r => r.json())
      .then(data => setStats(data))
      .catch(err => console.error('Erro ao carregar stats:', err))
      .finally(() => setLoading(false));
  }, []);

  const cards = stats ? [
    {
      title: 'CONTRIBUINTES ATIVOS',
      value: stats.contribuintes_ativos,
      subtitle: `${stats.contribuintes_total} cadastrados no total`,
      icon: <FaUsers />,
    },
    {
      title: 'PROTOCOLOS ABERTOS',
      value: stats.protocolos_abertos,
      subtitle: `${stats.protocolos_total} protocolos no total`,
      icon: <FaSyncAlt />,
    },
    {
      title: 'LICENÇAS VIGENTES',
      value: stats.licencas_vigentes,
      subtitle: `${stats.licencas_total} emitidas no total`,
      icon: <FaFileAlt />,
    },
    {
      title: 'VENCIMENTOS (30 DIAS)',
      value: stats.licencas_vencendo_30dias,
      subtitle: 'Licenças a vencer em breve',
      icon: <FaCalendarTimes />,
      alert: stats.licencas_vencendo_30dias > 0,
    },
  ] : [];

  const infoCards = stats ? [
    { label: 'Atividades CNAE ativas',  value: stats.cnae_ativas,   icon: <FaIndustry /> },
    { label: 'Tipos de licença',         value: stats.tipos_licenca, icon: <FaLeaf /> },
    { label: 'Técnicos cadastrados',     value: stats.tecnicos,      icon: <FaUserTie /> },
  ] : [];

  const actions = [
    { title: 'Nova Licença',           subtitle: 'Iniciar processo de licenciamento ambiental', icon: <FaLeaf />,        path: '/dashboard/abertura-processo' },
    { title: 'Cadastrar Contribuinte', subtitle: 'Adicionar novo contribuinte ao sistema',       icon: <FaUsers />,       path: '/dashboard/contribuintes' },
    { title: 'Abrir Protocolo',        subtitle: 'Registrar novo protocolo de processo',         icon: <FaClipboardList />, path: '/dashboard/protocolo-padrao' },
    { title: 'Consultar Processo',     subtitle: 'Buscar e acompanhar processos existentes',     icon: <FaSyncAlt />,     path: '/dashboard/consulta-processos' },
  ];

  return (
    <div className="home-container">
      <div className="welcome-banner">
        <h1>Bem-vindo ao GMA</h1>
        <p>Sistema de Gestão em Meio Ambiente — Controle Total e Eficiente</p>
      </div>

      {/* Cards principais */}
      <div className="stats-grid">
        {loading
          ? Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="stat-card stat-card--skeleton" />
            ))
          : cards.map((card, i) => (
              <div key={i} className={`stat-card${card.alert ? ' stat-card--alert' : ''}`}>
                <div className="stat-info">
                  <h3>{card.title}</h3>
                  <h2>{card.value ?? '—'}</h2>
                  <p>{card.subtitle}</p>
                </div>
                <div className="stat-icon-bg">{card.icon}</div>
              </div>
            ))}
      </div>

      {/* Cards de referência */}
      {!loading && (
        <div className="info-cards">
          {infoCards.map((c, i) => (
            <div key={i} className="info-card">
              <span className="info-card-icon">{c.icon}</span>
              <span className="info-card-value">{c.value ?? '—'}</span>
              <span className="info-card-label">{c.label}</span>
            </div>
          ))}
        </div>
      )}

      {/* Ações rápidas */}
      <div className="actions-section">
        <h2>Ações Rápidas</h2>
        <div className="actions-grid">
          {actions.map((action, i) => (
            <div key={i} className="action-card" onClick={() => navigate(action.path)} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && navigate(action.path)}>
              <div className="action-icon">{action.icon}</div>
              <h3>{action.title}</h3>
              <p>{action.subtitle}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
